var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFolderOpen = function SvgFolderOpen(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.5V6a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 .45.15l2.6 1.95a.75.75 0 0 0 .45.15h6.5a.75.75 0 0 1 .75.75v2.25",
    fill: "#1B2230"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.5V6a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 .45.15l2.6 1.95a.75.75 0 0 0 .45.15h6.5a.75.75 0 0 1 .75.75v2.25",
    stroke: "#1B2230",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m3 19.5 2.83-8.487a.75.75 0 0 1 .71-.513h14.92a.75.75 0 0 1 .71.987L19.5 19.5H3Z",
    fill: "#CBD4E1",
    stroke: "#CBD4E1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFolderOpen;